const Sliders = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 173 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M129 13H164C168.971 13 173 17.0294 173 22V22C173 26.9706 168.971 31 164 31H129V13Z"
        fill="currentColor"
      />
      <path
        d="M0 22C0 17.0294 4.02944 13 9 13H98V31H9C4.02944 31 0 26.9706 0 22V22Z"
        fill="currentColor"
      />
      <path
        d="M131 22C131 31.2835 123.272 39 113.5 39C103.728 39 96 31.2835 96 22C96 12.7165 103.728 5 113.5 5C123.272 5 131 12.7165 131 22Z"
        stroke="currentColor"
        strokeWidth="10"
      />
      <path
        d="M44 104L9 104C4.02944 104 3.52265e-07 99.9706 7.86805e-07 95V95C1.22135e-06 90.0294 4.02944 86 9 86L44 86L44 104Z"
        fill="currentColor"
      />
      <path
        d="M173 95C173 99.9706 168.971 104 164 104L75 104L75 86L164 86C168.971 86 173 90.0294 173 95V95Z"
        fill="currentColor"
      />
      <path
        d="M42 95C42 85.7165 49.7285 78 59.5 78C69.2715 78 77 85.7165 77 95C77 104.284 69.2715 112 59.5 112C49.7285 112 42 104.284 42 95Z"
        stroke="currentColor"
        strokeWidth="10"
      />
    </svg>
  )
}

export default Sliders
